import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import * as actions from '../../actions';
import * as c from '../../constants';

import AddChild from './ChildrenPanelAddItem';


class ChildrenPanelItem extends Component {
  constructor(props) {
    super(props);

    this.handleOnAddClick = this.handleOnAddClick.bind(this);
    this.handleOnEditClick = this.handleOnEditClick.bind(this);
    this.handleOnChildClick = this.handleOnChildClick.bind(this);
    this.handleOnDeleteClick = this.handleOnDeleteClick.bind(this);
    this.handleOnActiveToggle = this.handleOnActiveToggle.bind(this);
  }


  handleOnActiveToggle(event) {
    event.stopPropagation();

    const { item, toggleChildActive } = this.props;
    toggleChildActive(item);
  }


  handleOnAddClick() {
    const { showAddModal } = this.props;
    showAddModal(c.MODAL_MODE_ADD_CHILD);
  }


  handleOnDeleteClick(event) {
    event.stopPropagation();

    const { item, deleteChild } = this.props;
    const { active } = item;

    active
    && deleteChild(item);
  }


  handleOnEditClick(event) {
    event.stopPropagation();

    const { item, editHotkey } = this.props;
    const { active } = item;

    active
    && editHotkey(item, c.MODAL_MODE_EDIT_CHILD);
  }


  handleOnChildClick() {
    const { item, onChildClick } = this.props;
    const { active } = item;

    active
    && onChildClick
    && onChildClick(item)
  }


  render() {
    const { item: { key, name, active, is_group, is_template_group } } = this.props;
    const height = 120;

    if (key === c.ADD_DOC_ID) {
      return <AddChild label={name} height={height} onClick={this.handleOnAddClick} />;
    }

    return (
      <div className={`ui link card ht-card item ${!active && 'gray'}`} style={{ height }} onClick={this.handleOnChildClick}>
        <div className="content" style={{ padding: 5 }}>
          <div className="meta">
            <span className="ui fitted checkbox" style={{ paddingTop: 4 }} onClick={this.handleOnActiveToggle}>
              <input readOnly type="checkbox" checked={Boolean(active)} style={{ pointerEvents: 'none' }}/>
              <label></label>
            </span>
            <span onClick={this.handleOnEditClick}>
              <i className="ui large edit icon"></i>
            </span>
            {is_template_group &&
              <span className="ui right floated" onClick={this.handleOnDeleteClick}>
                <i className="ui large remove icon" />
              </span>
            }
          </div>
          <div className={`center aligned description ${is_group && 'ht-group-name'}`}>
            {name}
          </div>
        </div>
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  const { deleteChild, editHotkey, toggleChildActive, showAddModal } = actions;

  return bindActionCreators({
    editHotkey,
    deleteChild,
    showAddModal,
    toggleChildActive
  }, dispatch);
}


export default connect(null, mapDispatchToProps)(ChildrenPanelItem);
